import type Logger from "js/core/logger/Logger";

export function checkIfUpdateSetsSlideRefsToNull(changesetUpdates: any): boolean {
    // This is an invalid action that we are seeing in our logs
    // We want to log it as an error as part of investigating BA-19265, but will allow processing to continue
    if (!changesetUpdates || !("slideRefs" in changesetUpdates)) return false;

    const slideRefs = (changesetUpdates as any).slideRefs;
    return slideRefs === null || (typeof slideRefs === "object" && Object.keys(slideRefs).length === 0);
}

export function checkIfUpdateSetsAllButOneSlideToNull(changesetUpdates: any): boolean {
    // Detects when the update deletes multiple slides at one time, leaving a single one unchanged in the changeset
    // We want to log it as a warning as part of investigating BA-19265, though it may also occur based on a valid user action
    if (!changesetUpdates || !("slideRefs" in changesetUpdates)) return false;

    const rawSlideRefs = (changesetUpdates as any).slideRefs;
    if (!rawSlideRefs) return false;

    const slideRefs = Object.values((changesetUpdates as any).slideRefs);
    const nonNullSlideRefs = slideRefs.filter(v => v !== null);

    return (nonNullSlideRefs.length === 1 && slideRefs.length > 2);
}

export function troubleshootingLogs(changesetUpdates: any, logger: Logger): void {
    try {
        if (checkIfUpdateSetsSlideRefsToNull(changesetUpdates)) {
            // eslint-disable-next-line no-undef
            const undoManagerState = globalThis?.app?.undoManager?.getStateSnapshot?.();
            const err = new Error(`[StorageModel] update() set slideRefs to null`);
            logger.error(err, err.message,
                {
                    payload: JSON.stringify(changesetUpdates, null, 2),
                    undoManagerState
                });
        }
    } catch (err) {
        logger.error(err, `[StorageModel] update() apiAdapterUtils.checkIfUpdateSetsSlideRefsToNull() threw an error`);
    }

    try {
        if (checkIfUpdateSetsAllButOneSlideToNull(changesetUpdates)) {
            // eslint-disable-next-line no-undef
            const undoManagerState = globalThis?.app?.undoManager?.getStateSnapshot?.();
            const err = new Error(`[StorageModel] update() deleted all but the last slide`);
            logger.warn(err.message,
                {
                    trace: err.stack,
                    payload: JSON.stringify(changesetUpdates, null, 2),
                    undoManagerState
                });
        }
    } catch (err) {
        logger.error(err, `[StorageModel] update() apiAdapterUtils.checkIfUpdateSetsAllButOneSlideToNull() threw an error`);
    }
}
